export default __webpack_public_path__ + "static/media/Kebab.ffad9892.svg";